<template>
  <el-container class="height100">
    <el-aside width="200px" class="dept-aside overflowNone">
      <department_tree @node-click="onNodeClick"  :invalid="valid" />
    </el-aside>

    <el-container  class="overflowYHidden height100 User">
      <el-main v-show="showmode=='LIST'" class="el-mainContent paddingRight0 paddingLeft10 overflowYNone  flexColumn">
        <el-row class="obpm-fromContent-title obpm-enterpriseDomain-logo normalHeight">
          <el-col :span="12" class="normalLineH">{{$t('user_list')}}</el-col>
          <el-col :span="12" class="align-right normalLineH">
            <el-button type="primary" @click="onCreateBtnClick" size="small" v-if="!isSecret">{{$t('new')}}</el-button>
            <el-button type="primary" @click="onImportBtnClick" size="small" v-if='!flag' plain>{{$t('user_import')}}</el-button>
            <el-button type="primary" @click="onExportBtnClick" size="small" v-if='!flag' plain>{{$t('user_export')}}</el-button>
            <el-button @click="onDeleteBtnClick" size="small" type="danger" plain>离职移除</el-button>
            <!-- <el-button type="danger" @click="onDimissionBtnClick" size="small" plain>{{$t('resign')}}</el-button> -->
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form :inline="true" :model="searchdata" class="form-inline" size="mini"  @submit.native.prevent>
              <el-form-item  class="paddingLeft0">
                <el-input v-model="searchdata.data.name" placeholder="姓名" @keyup.enter.native="searchTableData"></el-input>
              </el-form-item>
              <el-form-item  class="paddingLeft0">
                <el-input v-model="searchdata.data.loginno" placeholder="手机号码" @keyup.enter.native="searchTableData"></el-input>
              </el-form-item>
              <el-form-item  class="paddingLeft0">
                <el-input v-model="searchdata.data.superiorname" :placeholder="$t('superior_name')" @keyup.enter.native="searchTableData"></el-input>
              </el-form-item>
              <el-form-item  class="paddingLeft0">
                <el-select v-model="application" class="el-select-w" placeholder="请选择应用">
                  <el-option label="" value="">
                    </el-option>
                  <el-option v-for="item in customApps" 
                    :key="item.id"
                    :label="item.name"
                    :value="item.name">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item  class="paddingLeft0">
                <el-select v-model="roleName" filterable class="el-select-w" :placeholder="$t('select_role')">
                  <el-option label="" value="">
                  </el-option>
                  <el-option v-for="item in roleList" 
                    :key="item.roleId"
                    :label="item.roleName"
                    :value="item.roleName">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item  class="paddingLeft0">
                <el-select v-model="searchdata.data.dimission" filterable class="el-select-w" :popper-append-to-body="false">
                  <el-option :label="$t('on_job')" :value="1"></el-option>
                  <!-- <el-option :label="$t('resign')" :value="0"></el-option> -->

                </el-select>
              </el-form-item>
              <!-- <el-form-item  class="paddingLeft0">
                <el-input v-model="searchdata.data.telephone" placeholder="请输入手机号" @keyup.enter.native="searchTableData"></el-input>
              </el-form-item> -->
              <el-form-item class="paddingLeft0" v-for="elm in SupportSearchList" :key="elm.id">
                <el-input v-model="searchdata.data[elm.name]" :placeholder="elm.label" @keyup.enter.native="searchTableData"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button @click="searchTableData" type="primary" plain >{{$t('query')}}</el-button>
                <el-button @click="resetSearchTableData">{{$t('reset')}}</el-button>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>

        <!-- 用户列表 -->
        <el-table
            stripe
            :data="tableData.datas"
            @row-click="onRowClick"
            ref="multipleTable"
            class="Trpointer"
            :row-key="handleReserve"
            @selection-change="handleSelectionChange"
            header-cell-class-name="tableHeaderbg"
            size="small"
            :height="tableListConHeight">
          <el-table-column type="selection" width="55" ></el-table-column>
          <el-table-column prop="name" label="姓名"></el-table-column>
          <el-table-column prop="loginno" label="手机号码"></el-table-column>
          <el-table-column prop="email" label="电子邮箱">
            <template slot-scope="scope">
              <span v-if="scope.row.emailPublic">{{scope.row.email}}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="dimission" :label="$t('dimission_status')">
            <template slot-scope="scope">
              <span>{{scope.row.dimission==0?$t('resign'):$t('on_job')}}</span>
            </template>
          </el-table-column> -->
          <el-table-column :label="$t('superior_name')" prop="superior.name"></el-table-column>

          <el-table-column v-for="(elm,index) in fieldextendsList" :key="index" :prop="elm.name" :label="elm.label"></el-table-column>

        </el-table>
        <!-- 分页 -->
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="searchTableData"
            :current-page.sync="searchdata.currpage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="searchdata.pagelines"
            layout="prev, pager, next, total, sizes"
            background
            :total="tableData.rowCount?tableData.rowCount:0"

        ></el-pagination>
      </el-main>
      <el-main v-show="showmode=='DETAIL'" class="el-mainContent">
        <user_detail :detail="content" @exit="onExit" v-if="showmode=='DETAIL'" :mode="mode"/>
      </el-main>
    </el-container>
    <fileUpload :visible.sync="fileUploadVisible" v-if="fileUploadVisible" :nowOption="nowOption" @success="searchTableData"/>

  </el-container>
</template>

<script>
import department_tree from "@/components/department_tree.vue";
import user_detail from "@/components/user_detail.vue";
import fileUpload from "@/components/fileUpload.vue";

export default {
  components: {
    department_tree,
    user_detail,
    fileUpload,
  },
  // props:['showListPart'],
  data() {
    return {
      flag:localStorage.getItem("isDeparmentAdminRole")=="false"?false:true,
      searchdata: {
        domainid: this.$route.query.domainid,
        departmentid: "",
        currpage: 1,
        pagelines: 10,
        orderby: "orderByNo",
        data:{
          name: "",
          loginno: "",
          superiorname: "",
          applicationid:"",
          roleid: "",
          dimission:'',
          telephone: "", // 手机号
        }
      },
      content: {}, //部门信息对象
      userSelectVisible: false,
      currentEditField: "", //PROXY
      tableData: [],
      showmode: "LIST", //LIST 或 DETAIL，默认为LIST
      multipleTable:[],
      valid:false,
      fieldextendsList:[],
      applicationId:"",
      customApps:[],
      roleList:[],
      multipleSelection:[],
      fileUploadVisible:false,
      nowOption:"import",
      tableListConHeight:null,
      mode:"detail",
      isSecret:false,
      SupportSearchList:[],
    };
  },
  computed:{
    roleName:{
      set(val){
        this.roleList.forEach(elm=>{
          if(elm.roleName==val){
            this.searchdata.data.roleid=elm.roleId;
          }
        });
        if(val==""){
          this.searchdata.data.roleid=""
        }
        return val;
      },
      get(){
        let v=null;
        if(this.roleList){
          this.roleList.forEach(elm=>{
            if(elm.roleId==this.searchdata.data.roleid){
              v=elm.roleName;
            }
          });
          if(this.searchdata.data.roleid==""){
            v="";
          }
        }
        return v;
      }
    },
    application:{
      set(val){
        this.customApps.forEach(elm=>{
          if(elm.name==val){
            this.applicationId=elm.id
          }
        })
        if(val==""){
          this.applicationId=""
        }else{
          this.getRoles();
        }
        return val;
      },
      get(){
        let v=""
        this.customApps.forEach(elm=>{
          if(elm.id==this.applicationId){
            v=elm.name
          }
        })
        if(this.applicationId==""){
          v=""
        }
        return v;
      }
    },
  },
  created() {
    if (this.$store.state.currentUser.type == 'secret') {
      this.isSecret= true;//是否是系统管理员
    }
    this.searchTableData();
    let dataJson={
      currpage:1,
      pagelines:30,
      data:{
        type:"",
        fortable:"tableUser",
        domainid: this.$route.query.domainid,
        belong:"All"
      }
    }
    this.$api.getFieldExtends(
      dataJson,
      {
        onSucess: resp => {
          resp.data.data.datas.forEach(elm=>{
            console.log("this.$route.query.domainid",this.$route.query.domainid)
            console.log("elm",elm)
            if(elm.enabel){
              this.fieldextendsList.push(elm);
            }
            if(elm.isSupportSearch){
              this.SupportSearchList.push(elm);
            }
          })
        }
      }
    );
    this.getCustomApp();
    this.getRoles();
    
    
  },
  mounted(){
    // var h = document.documentElement.clientHeight || document.body.clientHeight;
    this.tableListConHeight=this.$refs.multipleTable.$el.getClientRects()[0].height;

  },
  methods: {
    onImportBtnClick(){
      this.fileUploadVisible=true;
    },
    onExportBtnClick(){
      this.$api.exportUser(this.$route.query.domainid, 
        () => {
          this.$message({
            showClose: true,
            message: "导出成功!",
            type: "success"
          });
        }
      );
    },
    onDimissionBtnClick(){
      const selectData = this.multipleSelection;
      if(selectData.length == 0){
        this.$message({
          showClose: true,
          message: "请先选择用户!",
          type: "error"
        });
      }else{
        this.$api.abandonment(
          selectData,
          {
            onSucess: resp => {
              if(resp.data.errcode == 0){
                this.$message({
                  showClose: true,
                  message: resp.data.data,
                  type: "success"
                });
                this.searchTableData();
              }
            }
          }
        )
      }
    },
    getCustomApp(){
      this.$api.getCustomAppConfig(
        { domainid: this.$route.query.domainid, data:{name: ""} },
        {
          onSucess: resp => {
            this.customApps = resp.data.data.datas;
          }
        }
      )
    },
    getRoles(){
      if(this.applicationId!=""){
        this.$api.getRoleList(
          { applicationid: this.applicationId,pagelines: 10000000 },
          {
            onSucess: resp => {
              if(resp.data.data){
                this.roleList = resp.data.data.role ? resp.data.data.role : [];
              }else{
                this.roleList = [];
              }
              // this.$forceUpdate();
            }
          }
        );
      }
      
    },
      
    handleSelectionChange(val){
      var arr = [];
       val.forEach((val) => {
        this.tableData.datas.forEach((v) => {
          if(val.id == v.id){
            arr.push(val.id)
          }
        })
      })   
      this.multipleSelection = arr;
    },

    handleReserve(row){
      return row.id
    },

    onExit(){
      this.showmode = 'LIST';
      this.searchTableData();
    },
    
    onNodeClick(dept) {
      this.searchdata.departmentid = dept.id;
      this.searchTableData();
      this.showList();
    },
    
    onProxyUserBtnClick() {
      this.currentEditField = "proxyUser";
      this.userSelectVisible = true;
    },

    onSuperiorUserBtnClick() {
      this.currentEditField = "superior";
      this.userSelectVisible = true;
    },

    onSelectUserOk(users) {
      if (users && users.length > 0) {
        this.content[this.currentEditField] = users[0];
      }
    },
    showDetail(user) {
      this.content=JSON.parse(JSON.stringify(user));
      this.showmode = "DETAIL";
    },

    showList() {
      this.showmode = "LIST";
    },

    //新建
    onCreateBtnClick() {
      this.showDetail({startProxyTime:"",endProxyTime:"",dimission:1,status:1,permissionType:"public",roleDepartments:[],isCreate:true});
      this.mode="new";
    },

    onDeleteBtnClick(){
      if(this.multipleSelection.length>0){

          this.$confirm('是否对勾选的人员进行移除离职？', '提示', {
            confirmButtonText: this.$t('confirm'),
            cancelButtonText: this.$t('cancel'),
            type: 'warning'
          }).then(() => {
                this.$api.deleteUser({
                  data:this.multipleSelection
                },{
                  onSucess:resp =>{
                    if(resp.data.errcode==0){
                      this.$message({
                        showClose: true,
                        message: this.$t('msg_del_success'),
                        type: "success"
                      });
                      this.searchdata.data.name="";
                      this.searchTableData()
                    }else{
                      this.$message({
                          showClose: true,
                          message: resp.data.errmsg,
                          type: "error"
                        });
                    }
                  },
                  onError:function(){

                  }
                })
          }).catch(() => {                    
          }); 

      }else{
        this.$message({
          showClose: true,
          message: "请先选择用户!",
          type: "error"
        });
      }
    },
    handleSizeChange(size){
      this.searchdata.pagelines=size;
      this.searchTableData();
    },
    searchTableData() {
      if(this.searchdata.data.roleid!=""){
        this.roleList.forEach(elm=>{
          if(elm.roleName==this.searchdata.data.roleid){
            this.searchdata.data.roleid=elm.roleId;
          }
        })
      }
      this.searchdata.data.applicationid=this.applicationId;
      this.$api.getUsers(this.searchdata, {
        onSucess: resp => {
          this.tableData = resp.data.data;
        }
      });
    },

    onRowClick(row) {
      this.showDetail(row);
      this.mode="detail"
    },
    resetSearchTableData(){
      this.searchdata={
        domainid: this.$route.query.domainid,
        departmentid: this.searchdata.departmentid,
        currpage: 1,
        pagelines: 10,
        orderby: "",
        data:{
          name: "",
          loginno: "",
          superiorname: "",
          applicationid:this.applicationId,
          roleid: "",
          telephone: ""
        }
      }
      this.application="";
      this.searchTableData();
    }
  },
};
</script>

<style lang="scss" scoped>

</style>